import axios from 'axios';
import settings from '../../settings'

const Cast={
    namespaced:true,
    state:()=>({
       all:[],
    }),
    mutations:{
       UpdateState(state,data){
           state.all=data;
           state.staff=[];
       },
    },
    actions:{
        fetchCasts({commit},{page=1,query=''}){
            axios.get(`${settings.apiUrl}/casts?q=${query}&page=${page}`).then(res=>{
               commit('UpdateState',res.data);
            });
        },
        deleteCast({dispatch},staff){
            axios.post(`${settings.apiUrl}/casts/delete/${staff.id}`).then(res=>{
                dispatch('fetchCasts');
             });
        }
    },
}
export default Cast;